import styled from "styled-components";

export const LoaderWrap = styled.div`
    position:fixed;
    top:0;
    right:0;
    bottom:0;
    left:0;
    width:100%;
     height:100vh;
    background: rgb(17, 34, 51, 0.7);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    z-index:1001;
    display: flex;
    justify-content: center;
    align-items: center; 
`;
 

export const CommonLoader = styled.span`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: inline-block;
  border-top: 4px solid #FFF;
  border-right: 4px solid transparent;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;

    &::after {
        content: '';  
        box-sizing: border-box;
        position: absolute;
        left: 0;
        top: 0;
        width: 48px;
        height: 48px;
        border-radius: 50%;
        border-bottom: 4px solid #F9DC70;
        border-left: 4px solid transparent;
    }

    @keyframes rotation {
        0% {
        transform: rotate(0deg);
        }
        100% {
        transform: rotate(360deg);
        }
    } 
`;